/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Contact_EyebrowInputs */

const en_marketing_contact_eyebrow = /** @type {(inputs: Marketing_Contact_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const es_marketing_contact_eyebrow = /** @type {(inputs: Marketing_Contact_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacto`)
};

const fr_marketing_contact_eyebrow = /** @type {(inputs: Marketing_Contact_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

/**
* | output |
* | --- |
* | "Contact" |
*
* @param {Marketing_Contact_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_contact_eyebrow = /** @type {((inputs?: Marketing_Contact_EyebrowInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Contact_EyebrowInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_contact_eyebrow(inputs)
	if (locale === "es") return es_marketing_contact_eyebrow(inputs)
	return fr_marketing_contact_eyebrow(inputs)
});